// Immutable draft snapshots use the existing OWNER-ONLY essayAttempts schema.
// aiFeedback.status='draft' is explicitly ungraded, never a model result/mark.
// No new collection, rules, grade quota or browser-local private text.
import { MAX_ESSAY_CHARS } from './essayAttemptHelpers.js';

export function buildEssayDraft(input) {
    const own = input.source === 'own';
    const packId = own ? input.rubricPackId : input.packId;
    const promptId = own ? 'own' : input.promptId;
    if (typeof packId !== 'string' || packId.length > 120 || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(packId)
        || typeof promptId !== 'string' || !/^[A-Za-z0-9_-]{1,200}$/.test(promptId)
        || typeof input.essayText !== 'string' || !input.essayText.trim() || input.essayText.length > MAX_ESSAY_CHARS) return null;
    const body = { packId, promptId, essayText: input.essayText, aiFeedback: { status: 'draft' } };
    if (own) {
        if (typeof input.promptText !== 'string' || !input.promptText.trim() || input.promptText.length > 6000) return null;
        Object.assign(body, { source: 'own', rubricPackId: packId, promptText: input.promptText,
            promptTitle: input.promptText.slice(0, 200), packLabel: String(input.packLabel || '').slice(0, 200) });
    } else if (input.promptTitle) body.promptTitle = String(input.promptTitle).slice(0, 200);
    return body;
}

// One acknowledged snapshot per unchanged input in this mounted editor. Exact
// input comparison, not a weak content hash. Retry failures; coalesce double taps.
export function createDraftSaver(write) {
    let lastKey = null;
    let pending = null;
    return (uid, input) => {
        const body = buildEssayDraft(input);
        if (!uid || !body) return Promise.reject(new Error('Invalid draft.'));
        const key = JSON.stringify([uid, body]);
        if (key === lastKey && pending) return pending;
        lastKey = key;
        const operation = Promise.resolve().then(() => write(uid, body));
        pending = operation;
        operation.catch(() => { if (pending === operation) { lastKey = null; pending = null; } });
        return operation;
    };
}

export const isEssayDraft = attempt => attempt?.aiFeedback?.status === 'draft';
